import { AgmCoreModule } from "@agm/core";
import { AgmJsMarkerClustererModule } from "@agm/js-marker-clusterer";
import { DatePipe } from "@angular/common";
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { ReactiveFormsModule } from "@angular/forms";
import { FormsModule } from '@angular/forms';
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatSortModule } from "@angular/material/sort";
import { BrowserModule } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { NgxQRCodeModule } from "@techiediaries/ngx-qrcode";
import { ColorPickerModule } from "ngx-color-picker";
import { NgxDaterangepickerMd } from "ngx-daterangepicker-material";
import { NgxSpinnerModule } from "ngx-spinner";
import { ToastrModule } from "ngx-toastr";
import { JwtInterceptor, ErrorInterceptor, fakeBackendProvider } from "./_helpers";
import { AuthService } from "./_import/auth.service";
import { AuthenticationService } from "./_services";
import { BffAuthService } from "./_services/auth/auth.service";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { MobileUsersComponent } from "./components/Mobile/mobile-users/mobile-users.component";
import { RfidAllComponent } from "./components/Rfid/rfid-all/rfid-all.component";
import { RfidAssignComponent } from "./components/Rfid/rfid-assign/rfid-assign.component";
import { RfidCreateComponent } from "./components/Rfid/rfid-create/rfid-create.component";
import { RfidDetailsComponent } from "./components/Rfid/rfid-details/rfid-details.component";
import { RfidEditComponent } from "./components/Rfid/rfid-edit/rfid-edit.component";
import { RfidListComponent } from "./components/Rfid/rfid-list/rfid-list.component";
import { RfidUserComponent } from "./components/Rfid/rfid-user/rfid-user.component";
import { AddStationComponent } from "./components/Station/add-station/add-station.component";
import { DeviceAmenitiesComponent } from "./components/Station/station-details/device-amenities/device-amenities.component";
import { DeviceConfigComponent } from "./components/Station/station-details/device-config/device-config.component";
import { DeviceLogsComponent } from "./components/Station/station-details/device-logs/device-logs.component";
import { DeviceManageComponent } from "./components/Station/station-details/device-manage/device-manage.component";
import { DevicePhotosComponent } from "./components/Station/station-details/device-photos/device-photos.component";
import { DeviceSpecComponent } from "./components/Station/station-details/device-spec/device-spec.component";
import { DeviceTransComponent } from "./components/Station/station-details/device-trans/device-trans.component";
import { StationDetailsComponent } from "./components/Station/station-details/station-details.component";
import { StationsListComponent } from "./components/Station/stations-list/stations-list.component";
import { CreateVendorComponent } from "./components/Vedors/create-vendor/create-vendor.component";
import { VendorDetailsComponent } from "./components/Vedors/vendor-details/vendor-details.component";
import { AlertsAnsNotificationComponent } from "./components/alerts-ans-notification/alerts-ans-notification.component";
import { ChargingTransactionsComponent } from "./components/charging-transactions/charging-transactions.component";
import { CreateUserComponent } from "./components/create-user/create-user.component";
import { DashboardComponent } from "./components/dashboard/dashboard.component";
import { EditServiceRequestComponent } from "./components/edit-service-request/edit-service-request.component";
import { EditVendorServiceRequestComponent } from "./components/edit-vendor-service-request/edit-vendor-service-request.component";
import { FaqComponent } from "./components/faq/faq.component";
import { GrafanaComponent } from "./components/grafana/grafana.component";
import { HeaderComponent } from "./components/header/header.component";
import { MenuItemComponent } from "./components/header/menu-item/menu-item.component";
import { HomeComponent } from "./components/home/home.component";
import { InformationComponent } from "./components/information/information.component";
import { MapViewComponent } from "./components/map-view/map-view.component";
import { PrivacyPolicyComponent } from "./components/privacy-policy/privacy-policy.component";
import { ReferAfriendComponent } from "./components/refer-afriend/refer-afriend.component";
import { ReferalPageComponent } from "./components/referal-page/referal-page.component";
import { ServiceRequestComponent } from "./components/service-request/service-request.component";
import { ChargingProfilesComponent } from "./components/smart-charging/charging-profiles/charging-profiles.component";
import { CreateChargingProfileComponent } from "./components/smart-charging/create-charging-profile/create-charging-profile.component";
import { TariffManagementModule } from "./components/tariff-management/tariff-management.module";
import { TermsComponent } from "./components/terms/terms.component";
import { TicketsComponent } from "./components/tickets/tickets.component";
import { TransactionsComponent } from "./components/transactions/transactions.component";
import { UserTransactionsComponent } from "./components/user-transactions/user-transactions.component";
import { WalletsComponent } from "./components/wallets/wallets.component";
import { MaterialModule } from "./core/material.module";
import { DebounceClickDirectiveDirective } from "./debounce-click-directive.directive";
import { CoreService } from "./modules/ocpp/service/core.service";
import { FirmwareManagementService } from "./modules/ocpp/service/firmware-management.service";
import { LocalAuthorizationListManagementService } from "./modules/ocpp/service/local-authorization-list-management.service";
import { RemoteTriggerService } from "./modules/ocpp/service/remote-trigger.service";
import { ReservationService } from "./modules/ocpp/service/reservation.service";
import { SmartChargingService } from "./modules/ocpp/service/smart-charging.service";
import { MomentDateAdapterDirective } from "./moment-date-adapter.directive";
import { SafePipe } from "./safe.pipe";
import { SharedModule } from "./shared/shared.module";
import { AssetsSourcePipe } from "./theme/theme.pipe";
//import { CookieService } from "angular2-cookie/services";
import { LacMatTelInputModule } from "lac-mat-tel-input";
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatDateFormats } from "@angular/material/core";
import { NgxMatDateAdapter, NgxMatDatetimePickerModule, NgxMatNativeDateModule } from "@angular-material-components/datetime-picker";
import { CustomNgxDatetimeAdapter } from "./CustomNgxDatetimeAdapter";
import { MatMomentDateModule } from "@angular/material-moment-adapter";
import { BreadcrumbComponent } from "./components/breadcrumb/breadcrumb.component";
import { DeleteMobileComponent } from "./shared/delete-mobile/delete-mobile.component";



export function httpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

const CUSTOM_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'l, LTS'
  },
  display: {
    dateInput: 'YYYY-MM-DD HH:mm:ss',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  }
};

@NgModule({
  declarations: [
    BreadcrumbComponent,
    AppComponent,
    HomeComponent,
    DashboardComponent,
    HeaderComponent,
    MapViewComponent,
    AddStationComponent,
    AlertsAnsNotificationComponent,
    StationsListComponent,
    CreateVendorComponent,
    VendorDetailsComponent,
    StationDetailsComponent,
    MobileUsersComponent,
    ServiceRequestComponent,
    TicketsComponent,
    InformationComponent,
    EditServiceRequestComponent,
    EditVendorServiceRequestComponent,
    TransactionsComponent,
    DebounceClickDirectiveDirective,
    PrivacyPolicyComponent,
    TermsComponent,
    ReferAfriendComponent,
    MomentDateAdapterDirective,
    RfidListComponent,
    RfidCreateComponent,
    RfidEditComponent,
    RfidDetailsComponent,
    RfidAssignComponent,
    RfidUserComponent,
    RfidAllComponent,
    GrafanaComponent,
    SafePipe,
    ChargingProfilesComponent,
    CreateChargingProfileComponent,
    DeviceSpecComponent,
    DeviceConfigComponent,
    DeviceTransComponent,
    DeviceManageComponent,
    DeviceLogsComponent,
    AssetsSourcePipe,
    FaqComponent,
    DeviceAmenitiesComponent,
    DevicePhotosComponent,
    CreateUserComponent,
    ReferalPageComponent,
    MenuItemComponent,
    MenuItemComponent,
    WalletsComponent,
    UserTransactionsComponent,
    ChargingTransactionsComponent,
    DeleteMobileComponent
  ],
  imports: [
    ColorPickerModule,
    NgxSpinnerModule,
    SharedModule,
    BrowserModule.withServerTransition({ appId: 'evcharging' }),
    HttpClientModule,
    AppRoutingModule,
    // BrowserAnimationsModule,
    FlexLayoutModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    MatSortModule,
    NgxMatNativeDateModule,
    MatSnackBarModule,
    NgxMatDatetimePickerModule,
    NgxDaterangepickerMd.forRoot(),
    NgxQRCodeModule,
    TariffManagementModule,
    LacMatTelInputModule,
    NgxMatNativeDateModule,
    MatMomentDateModule,
    ToastrModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDG_VO2Iv_V1yAiUqQuMzG63IU7TrohVRg',
      libraries: ['places']
    }),
    AgmJsMarkerClustererModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient]
      },
      useDefaultLang: true
    })

  ],
  exports: [
    ToastrModule,
    ColorPickerModule
  ],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true, deps: [AuthenticationService, Router] },
  {
    provide: AuthService,
    useClass: BffAuthService
  },
  { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
    // provider used to create fake backend
    fakeBackendProvider,
    DatePipe,
    //CookieService,
    RemoteTriggerService, CoreService, ReservationService, LocalAuthorizationListManagementService, SmartChargingService, FirmwareManagementService],
  bootstrap: [AppComponent]
})

export class AppModule { }
export { AppComponent };

